module.exports = __webpack_public_path__ + "static/media/backtotop.6ed8e923.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/backtotop.svg
// module id = 1170
// module chunks = 28